import { useCallback, useId } from "react";
import { useTranslation } from "react-i18next";
import { useMatchAllTermsContext } from "@/features/match-all-terms";
import styles from "./MatchAllTerms.module.scss";

export const MatchAllTerms = () => {
    const { t } = useTranslation();
    const id = useId();
    const { matchAllTermsExactly, setMatchAllTermsExactly } = useMatchAllTermsContext();

    const onInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setMatchAllTermsExactly(e.target.checked);
        },
        [setMatchAllTermsExactly],
    );

    return (
        <div className={styles.matchAllTerms}>
            <input
                id={id}
                data-testid="SFS_matchAllTermsInput"
                className="checkbox"
                type="checkbox"
                checked={matchAllTermsExactly}
                onChange={onInputChange}
            />
            <label htmlFor={id}>{t("matchAllTermsExactly")}</label>
        </div>
    );
};
